import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=71fa117a&"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts&"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports